import Helpers from "../helpers.js";
export default class Floorplan {
	constructor() {
		this.selectors = {
			base: '[data-floorplan]',
			container: '[data-floorplan-container]',
			canvas: '[data-floorplan-canvas]',
			room: '[data-floorplan-room]',
			detail: '[data-floorplan-room-detail]',
			reserve: '[data-floorplan-room-reserve]',
			title: '[data-floorplan-room-names]'
		};

		this.attributes = {
			room: 'data-floorplan-room',
			bookable: 'data-floorplan-room-bookable',
			available: 'data-floorplan-room-available',
			types: 'data-floorplan-room-types'
		};

		this.classes = {
			hovered: 'hovered',
			opened: 'opened',
			bookable: 'bookable',
			available: 'available',
			active: 'active'
		};

		this.helpers = {
			isTouch: typeof window !== "undefined" && "ontouchstart" in window
		};
		
		this.states = {
			panning: false,
			animating: false
		};
		
		this.init();
	}

	init() {
		var self = this,
			$floorplans = $( self.selectors.base );

		$floorplans.each( function() {
			var floorplan = this,
				$floorplan = $( this ),
				$floorplanContainer = $floorplan.find( self.selectors.container ),
				$rooms = $floorplan.find( self.selectors.room ),
				floorplanPosition = $floorplanContainer[ 0 ].getBoundingClientRect();

			self.addFloorplanClasses( $floorplan );
			self.bindPanEvents( $floorplan, $rooms );

			$( window ).on( 'resize', Helpers.throttle( function() {
				floorplanPosition = $floorplanContainer[ 0 ].getBoundingClientRect();
			}, 200 ) );

			$rooms.each( function() {
				var $room = $( this ),
					roomID = $room.attr( self.attributes.room ),
					$roomShape = $floorplan.find( '#' + roomID );

				if ( $roomShape.length > 0 ) {
					self.addShapeClasses( $room, $roomShape );
					self.refreshRoom( $room, $roomShape );
					self.recalculatePosition( $room, $roomShape, floorplanPosition );
					self.bindRoomEvents( $floorplan, $rooms, $room, $roomShape );

					$( window ).on( 'resize', Helpers.throttle( function() {
						self.recalculatePosition( $room, $roomShape, floorplanPosition );
					}, 200 ) );

					$( theme.tabs.selectors.element ).on( 'change', function() {
						self.refreshRoom( $room, $roomShape );
					} );
				}
			} );

			$floorplan.trigger( 'floorplan:initialized' );
		} );
	}

	addFloorplanClasses( $floorplan ) {
		var self = this;

		if ( self.helpers.isTouch === true ) {
			$floorplan.addClass( 'touch' );
		}
		else {
			$floorplan.addClass( 'cursor' )
		}

		$floorplan.on( 'floorplan:initialized', function() {
			$floorplan.addClass( 'initialized' );
		} );
	}

	addShapeClasses( $room, $roomShape ) {
		var self = this,
		roomBookable = $room.attr( self.attributes.bookable ),
		roomAvailable = $room.attr( self.attributes.available );

		if ( roomBookable === 'yes' ) {
			$roomShape.addClass( self.classes.bookable );
		}

		if ( roomAvailable === 'yes' ) {
			$roomShape.addClass( self.classes.available );
		}
	}

	refreshRoom( $room, $roomShape ) {
		var self = this,
		roomTypes = $room.attr( self.attributes.types ).split(','),
		$roomDetail = $room.find( self.selectors.detail ),
		$roomTitle = $room.find( self.selectors.title );

		if ( roomTypes.indexOf( theme.tabs.states.current ) !== -1 ) { 
			var baseURL = $roomDetail.attr( 'data-floorplan-base-href' );
			
			$roomDetail.attr( 'href', baseURL + '?room-type=' + theme.tabs.states.current );
			$roomShape.addClass( self.classes.active );
		} else {
			var baseURL = $roomDetail.attr( 'data-floorplan-base-href' );

			$roomDetail.attr( 'href', baseURL );
			$roomShape.removeClass( self.classes.active );
		}

		var names = JSON.parse( $roomTitle.attr( 'data-floorplan-room-names' ) );

		if ( Object.keys( names ).length > 1 && names.hasOwnProperty(theme.tabs.states.current) ) {
			$roomTitle.html( names[theme.tabs.states.current] );
		}
	}

	recalculatePosition( $room, $roomShape, floorplanPosition ) {
		var roomPosition = $room[ 0 ].getBoundingClientRect(),
			roomShapePosition = $roomShape[ 0 ].getBoundingClientRect();

		$room.css( 'top', Math.round( roomShapePosition.top - floorplanPosition.top + ( roomShapePosition.height / 2 ) - ( roomPosition.height / 2 ) ) );

		if ( roomPosition.width > roomShapePosition.left ) {
			$room.addClass( 'right' );
			$room.css( 'left', Math.round( roomShapePosition.left - floorplanPosition.left + ( roomShapePosition.width - 10 ) ) );
		}
		else {
			$room.removeClass( 'right' );
			$room.css( 'left', Math.round( roomShapePosition.left - floorplanPosition.left - ( roomPosition.width - 10 ) ) );
		}
	}

	bindPanEvents( $floorplan, $rooms ) {
		var self = this,
			$floorplanContainer = $floorplan.find( self.selectors.container ),
			$floorplanCanvas = $floorplan.find( self.selectors.canvas );

		var startEvent = self.helpers.isTouch === true ? 'touchstart' : 'mousedown',
			moveEvent = self.helpers.isTouch === true ? 'touchmove' : 'mousemove',
			endEvent = self.helpers.isTouch === true ? 'touchend' : 'mouseup';

		var canvasWidth = $floorplanCanvas.width(),
			canvasHeight = $floorplanCanvas.height(),
			containerWidth = $floorplanContainer.width(),
			containerHeight = $floorplanContainer.height();

		var panX = 0,
			panY = 0,
			maxPanX = ( canvasWidth - containerWidth ),
			maxPanY = ( canvasHeight - containerHeight );

		$( window ).on( 'resize', Helpers.throttle( function() {
			canvasWidth = $floorplanCanvas.width(),
				canvasHeight = $floorplanCanvas.height(),
				containerWidth = $floorplanContainer.width(),
				containerHeight = $floorplanContainer.height();

			maxPanX = ( canvasWidth - containerWidth ),
				maxPanY = ( canvasHeight - containerHeight );
		}, 200 ) );

		$floorplanCanvas.css( 'transform', 'translate3d(' + panX + 'px, ' + panY + 'px, 0)' );

		$floorplan.on( 'floorplan:center', function( e, $room ) {
			self.states.animating = true;
			$floorplanCanvas.css( 'transition-property', 'transform' );
			$floorplanCanvas.css( 'transition-duration', '1000ms' );

			var $room = $( $room );

			panX = parseInt( $room.css( 'left' ) ) - ( $floorplanContainer.width() / 2 ) + ( $room.outerWidth() / 2 );
			panY = parseInt( $room.css( 'top' ) ) - ( $floorplanContainer.height() / 2 ) + ( $room.outerHeight() / 2 );

			if ( panX < 0 ) {
				panX = 0;
			}
			else if ( panX > maxPanX ) {
				panX = maxPanX;
			}

			if ( panY < 0 ) {
				panY = 0;
			}
			else if ( panY > maxPanY ) {
				panY = maxPanY;
			}

			$floorplanCanvas.css( 'transform', 'translate3d(-' + panX + 'px, -' + panY + 'px, 0)' );

			setTimeout( function() {
				self.states.animating = false;

				$floorplanCanvas.css( 'transition-property', '' );
				$floorplanCanvas.css( 'transition-duration', '' );
			}, 1000 );
		} );

		$floorplanContainer.on( startEvent, function( e ) {
			if ( self.states.animating === true || ( ( containerWidth >= canvasWidth ) && containerHeight >= canvasHeight ) ) {
				return;
			}

			e.preventDefault();

			var startX = self.helpers.isTouch === true ? e.originalEvent.touches[ 0 ].pageX : e.originalEvent.clientX;
			var startY = self.helpers.isTouch === true ? e.originalEvent.touches[ 0 ].pageY : e.originalEvent.clientY;

			var startPanX = panX;
			var startPanY = panY;

			var target = e.originalEvent.target,
				$room = $( target ).closest( self.selectors.room );

			if ( $room.length < 1 ) {
				$rooms.removeClass( self.classes.opened );
			}

			$floorplanContainer.on( moveEvent, function( e ) {
				e.preventDefault();

				var currentX = self.helpers.isTouch === true ? e.originalEvent.touches[ 0 ].pageX : e.originalEvent.clientX;
				var currentY = self.helpers.isTouch === true ? e.originalEvent.touches[ 0 ].pageY : e.originalEvent.clientY;

				var deltaX = startX - currentX;
				var deltaY = startY - currentY;

				panX = startPanX + deltaX;
				panY = startPanY + deltaY;

				if ( deltaX !== 0 || deltaY !== 0 ) {
					self.states.panning = true;
				}

				if ( panX < 0 ) {
					panX = 0;
				}
				else if ( panX > maxPanX ) {
					panX = maxPanX;
				}

				if ( panY < 0 ) {
					panY = 0;
				}
				else if ( panY > maxPanY ) {
					panY = maxPanY;
				}

				$floorplanCanvas.css( 'transform', 'translate3d(' + -( panX ) + 'px, ' + -( panY ) + 'px, 0)' );
			} );
		} );

		var $endEventElement = self.helpers.isTouch === true ? $floorplanContainer : $( document.body );

		$endEventElement.on( endEvent, function( e ) {
			e.preventDefault();

			$floorplanContainer.off( moveEvent );

			setTimeout( function() {
				self.states.panning = false;
			}, 100 );
		} );
	}

	bindRoomEvents( $floorplan, $rooms, $room, $roomShape ) {
		var self = this;

		if ( self.helpers.isTouch === true ) {
			self.bindTouchEvents( $floorplan, $rooms, $room, $roomShape );
		}
		else {
			self.bindEvents( $floorplan, $rooms, $room, $roomShape );
		}
	}

	bindEvents( $floorplan, $rooms, $room, $roomShape ) {
		var self = this;

		$room.on( 'mouseenter', function() {
			if ( $room.hasClass( self.classes.opened ) === false ) {
				$room.addClass( self.classes.opened );
			}
			$roomShape.addClass( self.classes.hovered );
		} );

		$room.on( 'mouseleave', function() {
			$room.removeClass( self.classes.opened );
			$roomShape.removeClass( self.classes.hovered );
		} );

		$roomShape.on( 'mouseenter', function() {
			if ( $roomShape.hasClass( 'active' ) ) {
				$rooms.removeClass( self.classes.opened );
				$room.addClass( self.classes.opened );
			}
		} );

		$roomShape.on( 'mouseleave', function() {
			$rooms.removeClass( self.classes.opened );
		} );

		$roomShape.on( 'click', function() {
			if ( self.states.panning === false && $roomShape.hasClass( 'active' ) ) {
				var detailUrl = $room.find( self.selectors.detail );

				if ( detailUrl.length > 0 ) {
					window.location.href = $room.find( self.selectors.detail ).attr( 'href' );
				}
			}
		} );

		$room.find( self.selectors.reserve ).on( 'click', function( e ) {
			e.preventDefault();
			e.stopPropagation();

			var $this = $( this ),
				roomID = $this.attr( 'data-floorplan-room-reserve' ),
				roomAvailability = $room.attr( self.attributes.available ),
				switchedAvailability = '';

			if ( roomAvailability === 'yes' ) {
				switchedAvailability = 'no';
			}
			else {
				switchedAvailability = 'yes';
			}

			jQuery.post( themeVars.ajax_url, 'action=rooms_change_availability&room=' + roomID + '&value=' + switchedAvailability, function( response ) {
				if ( response.data.available === 'yes' ) {
					$roomShape.addClass( self.classes.available );
					$this.addClass( self.classes.available );
				}
				else {
					$roomShape.removeClass( self.classes.available );
					$this.removeClass( self.classes.available );
				}

				$room.attr( self.attributes.available, response.data.available );
			} );

		} );
	}

	bindTouchEvents( $floorplan, $rooms, $room, $roomShape ) {
		var self = this;

		$roomShape.on( 'touchend', function() {
			if ( self.states.panning === false && self.states.animating === false ) {
				$rooms.removeClass( self.classes.opened );
				$room.addClass( self.classes.opened );

				$floorplan.find( '.' + self.classes.hovered ).removeClass( self.classes.hovered );
				$roomShape.addClass( self.classes.hovered );

				$floorplan.trigger( 'floorplan:center', $room );
			}
		} );

		$room.on( 'touchend', function( e ) {
			var $target = $( e.originalEvent.target );

			if ( self.states.panning === false && $target.is( 'a' ) ) {
				window.location.href = $target.attr( 'href' );
			}
		} );
	}
}